import {
  IntegrationUsageLogColumnKeyEnum,
  IntegrationUsageLogFormatEnum,
  IntegrationUsageLogWhere,
  useExportIntegrationUsageLogsLazyQuery,
} from 'src/api';
import { useNotification } from 'src/hooks/app';
import { downloadFileByDownloadUrl } from 'src/utils/file';

export const useExportIntegrationUsageLogs = () => {
  const { createApolloContext } = useNotification();

  const [exportQuery, { loading }] = useExportIntegrationUsageLogsLazyQuery({
    context: createApolloContext({ errorMessage: 'Failed to export usage logs' }),
  });

  const exportUsageLogs = async (
    integrationName: string | undefined,
    where: IntegrationUsageLogWhere,
    columns: IntegrationUsageLogColumnKeyEnum[],
    format: IntegrationUsageLogFormatEnum,
  ): Promise<boolean> => {
    const { data } = await exportQuery({ variables: { input: { where, columns, format } } });

    if (data?.exportIntegrationUsageLogs) {
      downloadFileByDownloadUrl(
        data.exportIntegrationUsageLogs,
        `${integrationName ?? 'Integration'}_logs.${format}`,
      );
      return true;
    }

    return false;
  };

  return { exportUsageLogs, exporting: loading };
};
